import { useI18n } from "@/lib/i18n";
import { SITE_COPY } from "@/lib/siteContent";

export function TimelineSection() {
  const { lang } = useI18n();
  const c = SITE_COPY[lang].timeline;

  return (
    <section className="mx-auto max-w-5xl px-4 pb-16 md:px-6">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent">{c.eyebrow}</p>
      <h2 className="mt-3 font-serif text-2xl text-foreground md:text-4xl">{c.title}</h2>

      <ol className="mt-10 border-l border-border">
        {c.items.map((m) => (
          <li key={m.n} className="relative pb-10 pl-8 last:pb-0">
            <span className="absolute -left-[9px] top-1.5 h-4 w-4 rounded-full border-2 border-accent bg-background" />
            <span className="font-serif text-2xl text-accent/60">{m.n}</span>
            <h3 className="mt-1 text-lg font-semibold text-foreground">{m.title}</h3>
            {m.subtitle && (
              <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
                {m.subtitle}
              </p>
            )}
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-muted-foreground">{m.text}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}
